/**
 * `SITE-SPD04`: the Playground's languages as the site's chrome links them (the
 * footer's compilers row, the More panel's count): id, name and page slug only.
 *
 * The footer and the More panel are on every page; importing `languages.ts`
 * for this list put the whole backend language contract and its validation in
 * the script every page loads. This copy is checked against
 * `PLAYGROUND_LANGUAGES` in `languages.contract.test.ts`, which `prebuild` runs
 * (`verify:playground-languages`), so a build stops when the two disagree.
 */
export const PLAYGROUND_LANGUAGE_LINKS: readonly { id: string; name: string; seoSlug: string }[] = [
  { id: "c", name: "C", seoSlug: "c" },
  { id: "cpp", name: "C++", seoSlug: "cpp" },
  { id: "python", name: "Python 3", seoSlug: "python" },
  { id: "java", name: "Java", seoSlug: "java" },
  { id: "javascript", name: "JavaScript (Node.js)", seoSlug: "javascript" },
  { id: "typescript", name: "TypeScript", seoSlug: "typescript" },
  { id: "go", name: "Go", seoSlug: "go" },
  { id: "rust", name: "Rust", seoSlug: "rust" },
  { id: "php", name: "PHP", seoSlug: "php" },
  { id: "ruby", name: "Ruby", seoSlug: "ruby" },
];
